import React, { useEffect, useState } from 'react';
import { Text, View, ScrollView, Pressable } from 'react-native';
import { styles } from './genre-bar.styles';
import { genres } from './genre-data';

const GenreBar = ({ updateGenreSearch, fetchedGenres }) => {
	const [genrePop, changeGenrePop] = useState('false');
	const [genresState, setGenresState] = useState(fetchedGenres);

	const pressGenre = (genreName) => {
		const newGenres = fetchedGenres.map((genre) => {
			if (genre.genre === genreName) {
				genre.active = !genre.active;
			}
			return genre;
		});
		setGenresState(newGenres);
		updateGenreSearch(newGenres);
	};

	const genreArray = fetchedGenres.map((genre) => {
		if (genre.active) {
			return (
				<Pressable
					key={genre.genre}
					style={[styles.genreBar__genre, { borderWidth: 0, padding: 10, backgroundColor: `${genre.color}` }]}
					onPress={() => {
						pressGenre(genre.genre);
					}}
				>
					<Text style={[styles.genreBar__genre__text, { color: `#fff` }]}>{genre.genre}</Text>
				</Pressable>
			);
		} else {
			return (
				<Pressable
					key={genre.genre}
					style={[styles.genreBar__genre, { borderColor: `#adb5bd` }]}
					onPress={() => {
						pressGenre(genre.genre);
					}}
				>
					<Text style={[styles.genreBar__genre__text, { color: `#adb5bd` }]}>{genre.genre}</Text>
				</Pressable>
			);
		}
	});
	return (
		<View style={styles.genreBar__container}>
			<ScrollView style={styles.genreBar} horizontal={true} showsHorizontalScrollIndicator={false}>
				{genreArray}
			</ScrollView>
		</View>
	);
};

export default GenreBar;
